import { useTranslation } from "react-i18next";

import DefaultAuth from "../DefaultAuth";
import ResetPasswordForm from "../Forms/ResetPassword";

export default function ResetPassword() {
	const { t } = useTranslation();

	return (
		<DefaultAuth
			Form={ResetPasswordForm}
			title={t("auth.resetPassword.form.title")}
		/>
	);
}
